var _linearGradient, _linearGradient2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(189.38 0 0 189.81 25243.061 38519.17)",
    gradientUnits: "userSpaceOnUse",
    x1: -133.268,
    x2: -133.198,
    y1: -202.91,
    y2: -202.84
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#387eb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(189.38 0 0 189.81 25309.061 38583.42)",
    gradientUnits: "userSpaceOnUse",
    x1: -133.575,
    x2: -133.495,
    y1: -203.203,
    y2: -203.133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc331"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.885 2.1c-7.1 0-6.651 3.07-6.651 3.07v3.19h6.752v1h-9.441s-4.545-.56-4.545 6.645 4.013 6.912 4.013 6.912h2.317v-3.361s-.13-4.013 3.9-4.013h6.762s3.772.06 3.772-3.652v-6.091s.572-3.712-6.842-3.712zm-3.732 2.137a1.214 1.214 0 1 1 -1.183 1.244v-.02a1.214 1.214 0 0 1 1.214-1.214z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.085 29.91c7.1 0 6.651-3.08 6.651-3.08v-3.18h-6.751v-1h9.47s4.545.508 4.545-6.655-4.013-6.912-4.013-6.912h-2.347v3.317s.13 4.013-3.9 4.013h-6.765s-3.775-.057-3.775 3.655v6.132s-.572 3.712 6.842 3.712h.04zm3.732-2.147a1.214 1.214 0 1 1 1.183-1.244v.03a1.214 1.214 0 0 1 -1.214 1.214h.03z",
    fill: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.744ffb84e4cd8e0d59bdac6f3f4b1e4b.svg";
export { ForwardRef as ReactComponent };